<div *ngIf="present()" class="cookie-banner">
  <p>W celu zapewniania najlepszych usług aplikacja zapisuje część informacji w tzw. ciastkach.
  Korzystając z aplikacji zgadzasz się na ich użycie. Poznaj naszą <a target="_blank" href="https://www.se.com/pl/pl/about-us/legal/data-privacy.jsp">Politykę prywatności</a>.</p>
  <button class="cookie-banner-consent-button" (click)="accept()">Akceptuję</button>
</div>

    
